import React from 'react';
import FeatureSettings from '../FeatureSettings/FeatureSettings';
import { VenueSettingsContainer } from './VenueSettings.styles';

const VenueSettings = () => {
  return (
    <VenueSettingsContainer>
      <FeatureSettings />
    </VenueSettingsContainer>
  );
};

export default VenueSettings;
